import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteAbschnittCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteAbschnittCommandService],
  exports: []
})
export class DeleteAbschnittCommandServiceModule { }
